//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "conduct",
  props: {
    goodsList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    suspend_status: {
      type: Boolean,
      default: false,
    },

    iSgold: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      move_start: false, //显示
      volutionList: [], //列表
      key: 0, //单独绑定key
      iden: [], //结束
    };
  },
  computed: {
    /** 乱序奖品池 */
    random_case_awards: (vm) => {
      // 生成一轮奖品
      const generate_round_awards = () =>
        Array(50)
          .fill(null)
          .map(
            () =>
              vm.goodsList.filter((item) => item.groupId != 3)[
                parseInt(
                  Math.random() *
                    vm.goodsList.filter((item) => item.groupId != 3).length
                )
              ]
          );

      return generate_round_awards();
    },
  },
  methods: {
    //第一步
    step(prize_item) {
      this.reset();

      this.volutionList = this.random_case_awards;
      if (this.iSgold || prize_item.groupId != 3) {
        this.$set(this.volutionList, 44, prize_item); //设置开奖结果
      } else {
        let item = { gold: true };
        this.$set(this.volutionList, 44, item); //设置开奖结果
      }

      this.start();
    },

    //显示
    start() {
      console.log("开始滚动");
      //声音是否
      this.$nextTick(() => {
        var award_opened = this.$refs[`roll_item_44`][0];
        var award_hit_line = this.$refs.hitLine;

        var move_pixel = award_opened.getBoundingClientRect().left - award_hit_line.getBoundingClientRect().left;
        var offset_pixel = Math.round(award_opened.getBoundingClientRect().width * Math.random());
        var move_pixel_real = move_pixel + offset_pixel;

        this.$refs.enlarge.style.transition =
          "transform 5.6s cubic-bezier(0, 0.11, 0.33, 1) 0s";
        this.$refs.enlarge.style.transform = `translateX(-${move_pixel_real}px)`;
        this.$refs.normal.style.transition =
          "transform 5.6s cubic-bezier(0, 0.11, 0.33, 1) 0s";
        this.$refs.normal.style.transform = `translateX(-${move_pixel_real}px)`;
        this.move_start = true;
      });
    },

    //动画结束
    transitionend() {
      this.iden.push("end");
      if (this.iden.length == 2) {
        setTimeout(() => {
          if (!this.suspend_status) {
            this.move_start = false;
            this.$emit("move_end");
            setTimeout(() => {
              this.$refs.enlarge.style.transition = "none";
              this.$refs.enlarge.style.transform = "translateX(0)";
              this.$refs.normal.style.transition = "none";
              this.$refs.normal.style.transform = "translateX(0)";
            }, 300);
          }
        }, 500);
      }
    },

    //开箱终止
    reset() {
      this.iden = [];
      this.move_start = false;
      this.volutionList = [];
      this.$refs.enlarge.style.transition = "none";
      this.$refs.enlarge.style.transform = "translateX(0)";
      this.$refs.normal.style.transition = "none";
      this.$refs.normal.style.transform = "translateX(0)";
    },
  },
  watch: {
    goodsList(v) {
      this.iden = [];
    },
  },
};
